import styled from "styled-components";

const OptionStep = styled.div`
  margin-bottom: 30px;
`;

const TitleStep = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

const BodyStep = styled.div``;

const StepNumber = styled.p`
  color: #f00;
  font-size: 17px;
  font-weight: bold;
  margin-right: 10px;
`;

const StepDescription = styled.p`
  font-size: 15px;
`;

export { OptionStep, TitleStep, BodyStep, StepNumber, StepDescription };
